// pages/LoginPage/hooks/useLogin.ts

import { useState } from 'react';
import { useAuth } from '../../../shared/context/AuthContext';
import { useApiError } from '../../../shared/hooks/useApiError';
import { ERROR_CODES } from '../../../shared/types/errors';
import authService from '../services/authService';

export function useLogin() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  
  // customMessages solo cuando quieres SOBRESCRIBIR el mensaje por defecto
  const { handleError } = useApiError({
    notificationStrategy: {
      showError: (message) => setError(message),
    },
    // Estos mensajes ya están en errorMessages.ts, no hace falta repetirlos
    // Solo personaliza si necesitas un mensaje MÁS ESPECÍFICO para este contexto
  });

  const handleLogin = async (email: string, password: string, captchaToken?: string) => {
    setIsLoading(true);
    setError('');

    try {
      if (!email || !password) {
        throw new Error('Email y contraseña son requeridos');
      }

      const response = await authService.login({
        email_user: email,
        password_user: password,
        captchaToken,
      });
      // Guarda token y usuario en el contexto
      login(response.token, response.user);

    } catch (err) {
      handleError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return { login: handleLogin, isLoading, error };
}